import React, { useContext } from 'react';
import S from "./Risk.styled";
import CardHeader from "../CardHeader";
import FundContext from "@/components/FundSingle/FundProvider";
import RiskMeter from './RiskMeter';
import Star from '@/assets/star.svg';
import StarFilled from '@/assets/star-filled.svg';
import RiskRatingMappings from "./risk-rating-mappings.json";

const Risk: React.FC<FundSingle> = () => {

    // Get the data from the context
    const { fundRiskDetails, securityId } = useContext(FundContext);

    if (Object.keys(fundRiskDetails).length === 0) {
        return null;
    }

    var riskAndRating = fundRiskDetails.RiskAndRating;
    if (!riskAndRating) {
        return null;
    }

    var overallRiskRatingItem = riskAndRating.find(item => item.TimePeriod === 'M255');

    var riskRating = fundRiskDetails.KID.SRI;
    var morningstarRating = Math.round(overallRiskRatingItem.RatingValue * 10) / 10;

    var benchmarkIndexName = fundRiskDetails.Benchmark[0].Name;
    var morningstarBenchmarkName = fundRiskDetails.Benchmark[1].Name;

    const renderStars = (rating: number) => { 
        const stars = [];
        for (let i = 0; i < 5; i++) {
            if (i < rating) {
                stars.push(<StarFilled key={i} />);
            } else {
                stars.push(<Star key={i} />);
            }
        }
        return stars;
    }

    return (
        <S.RiskWrapper>
            <CardHeader title="Risk" />
            <S.RiskBarWrapper>
                <RiskMeter rating={riskRating} />
                <S.RiskBarLowLabel>Låg</S.RiskBarLowLabel>
                <S.RiskBarRating>{riskRating}</S.RiskBarRating>
                <S.RiskBarHighLabel>Hög</S.RiskBarHighLabel>
            </S.RiskBarWrapper>

            <S.RiskMorningstarRating>
                <S.RiskMorningstarRatingTitle>Morningstar betyg</S.RiskMorningstarRatingTitle>
                <S.RiskMorningstarRatingStars>
                    {renderStars(morningstarRating)}
                </S.RiskMorningstarRatingStars>
            </S.RiskMorningstarRating>

            <S.RiskComparisonTitle>Jämnförelseindex</S.RiskComparisonTitle>

            <S.RiskSubTitleWrapper>
                <S.RiskSubTitleHeading>Fondens jämförelseindex</S.RiskSubTitleHeading>
                <S.RiskSubTitleValue>{benchmarkIndexName}</S.RiskSubTitleValue>
            </S.RiskSubTitleWrapper>

            <S.RiskSubTitleWrapper>
                <S.RiskSubTitleHeading>Morningstar® Benchmark</S.RiskSubTitleHeading>
                <S.RiskSubTitleValue>{morningstarBenchmarkName}</S.RiskSubTitleValue>
            </S.RiskSubTitleWrapper>

        </S.RiskWrapper>
    );
};

export default Risk;
